import { useSellersShield } from 'components/SellersShield/hooks/useSellersShield';

import type { IntegrationState } from './types';
import { useHasShown } from './useHasShown';

export function useShowSellersShield(): IntegrationState {
  const { showOnboardingDialog, isLoading } = useSellersShield();

  const hasShown = useHasShown(showOnboardingDialog);

  return {
    show: showOnboardingDialog,
    isLoading,
    hasShown,
  };
}
